

const TicketNav = (props) => {
    const {
        tabName,
        selected,
        tabDisplayName,
        handleSelectTicketTab,
        poleIssue
    } = props;
    
    return (
        <a className={`nav-item nav-link m-0 text-center modalNavLink ${selected ? "active" : ''} ${poleIssue ? "disabled" : ''}`}
                        id={`nav-${tabName}-tab`} data-toggle="tab" role="tab" aria-controls={`nav-${tabName}`} aria-selected="true"
                        onClick={() => handleSelectTicketTab(tabName)}
                    >{tabDisplayName}</a>
    );
}

export default TicketNav